import React, { useEffect } from "react";
import HeaderTransprent from "../../components/HeaderTransprent.js"
import Footer from "../../components/Footer.js";
import ContactForm from "../../components/ui/ContactForm.js";
// import { GoMail } from "react-icons/go";
// import { TbBuilding } from "react-icons/tb";

const ContactUs = () => {

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>

      <div className="">
        {/* <section className="bg-[#FFFFFF] w-full h-auto bg-cover bg-no-repeat bg-right">
          <HeaderTransprent />
          <div className="w-full h-full bgpagecolor">
            <div className="flex flex-col w-full h-full py-10 2xl:w-9/12 xl:w-11/12 xl:px-0 px-4 mx-auto">
              <div data-aos="fade-up" className="space-y-2 text-[#3D405B] flex flex-col justify-center items-center">
                <h1 className="xl:text-6xl text-5xl leading-[3rem] xl:leading-[3.5rem] font-bold textcolor capitalize"></h1>
              </div>
            </div>
          </div>
        </section> */}
        <section className="bg-cover bg-no-repeat bg-right w-full h-auto" style={{ backgroundImage: `url('/assets/home/index-hero-section.webp')`, }}>
          <HeaderTransprent />
          <div className="w-full h-full">
            <div className="flex flex-col w-full h-full py-16 2xl:w-9/12 xl:w-11/12 xl:px-0 px-4 mx-auto">
              <div data-aos="fade-up" className="space-y-2 text-[#3D405B] flex flex-col justify-start items-start">
                <h1 className="xl:text-6xl text-5xl leading-[3rem] xl:leading-[3.5rem] font-bold text-white capitalize">Let’s Connect</h1>
              </div>
            </div>
          </div>
        </section>

        <section className="bg-cover bg-no-repeat py-16" style={{ backgroundImage: `url('/img/home/bg-03.webp')`, }}>
          <div className="flex flex-col justify-start w-full h-full 2xl:w-9/12 xl:w-11/12 xl:px-0 px-4 mx-auto">
            <div className="mx-auto px-4 py-12 w-full">
              <div className="flex flex-col lg:flex-row">
                <div className="lg:w-1/2 flex flex-col justify-center md:mb-0 pr-0 md:pr-10">
                  <div className="flex items-center justify-center w-full">
                    <img src="/assets/home/contact-us.webp" alt="Lead with Clarity" className="z-0" />
                  </div>
                </div>
                <ContactForm />
              </div>
            </div>
          </div>
        </section>

        <Footer />
      </div>
    </>
  );
}


ContactUs.defaultProps = {
  center: { lat: 26.953021, lng: 75.739797 },
  zoom: 15,
};


export default ContactUs;
